import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Header from '../components/Header'
import GridUnit from '../components/GridUnit'
import Section from '../components/Section'
import BackArrow from '../components/BackArrow'
import Button from '../components/Button'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPowerOff,
  faGlobe,
  faWrench,
  faShieldAlt,
  faCloud,
  faDna,
  faUniversity,
  faShoppingBag,
  faCreditCard,
  faPlane,
  faSuitcase,
  faNewspaper,
  faUsers,
  faBullhorn,
  faChartArea,
  faShareAltSquare,
  faFireExtinguisher,
  faBroadcastTower,
  faPlug,
  faCogs,
  faSmile,
  faPuzzlePiece,
  faFile,
} from '@fortawesome/free-solid-svg-icons'
library.add([
  faPowerOff,
  faGlobe,
  faWrench,
  faShieldAlt,
  faCloud,
  faDna,
  faUniversity,
  faShoppingBag,
  faCreditCard,
  faPlane,
  faSuitcase,
  faNewspaper,
  faUsers,
  faBullhorn,
  faChartArea,
  faShareAltSquare,
  faFireExtinguisher,
  faBroadcastTower,
  faPlug,
  faCogs,
  faSmile,
  faPuzzlePiece,
  faFile,
])

import './style.scss'

class ServicesPage extends Component {
  constructor(props) {
    super(props)
  }
  componentWillMount() {}
  render() {
    return (
      <div className="index">
        <div className="main">
          <Helmet title="Fleisher Communications - Services" />
          <BackArrow />

          {/* What we do */}
          <Section title="What we do">
            <div className="row about_header">
              <div className="col-xs-12 col-sm-8 col-md-6">
                <h3>
                  <b>
                    We specialise in positioning our clientele as{' '}
                    <span className="orange">leaders</span> in their target
                    markets.
                  </b>
                </h3>
              </div>
            </div>
          </Section>

          {/* Sectors */}
          <Section title="Sectors">
            <div className="row">
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="power-off" />
                <p>
                  <b>Infrastructure & Energy</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="globe" />
                <p>
                  <b>Telecommunications, Internet & Communications</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="wrench" />
                <p>
                  <b>Industrial</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="shield-alt" />
                <p>
                  <b>Insurance</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="cloud" />
                <p>
                  <b>Hi-tech & Technology</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="dna" />
                <p>
                  <b>Bio technology & Medicine</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="university" />
                <p>
                  <b>Government offices & Companies</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="shopping-bag" />
                <p>
                  <b>Consumerism</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="credit-card" />
                <p>
                  <b>Finance & Capital markets</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="plane" />
                <p>
                  <b>Tourism & Aviation</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="suitcase" />
                <p>
                  <b>Holding companies</b>
                </p>
              </div>
            </div>
          </Section>

          <Section title="Practice">
            <div className="row">
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="newspaper" />
                <p>
                  <b>Public relations</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="users" />
                <p>
                  <b>Media relations</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="bullhorn" />
                <p>
                  <b>Active spokesmanship</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="chart-area" />
                <p>
                  <b>Financial public relations</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon
                  className="service_icon"
                  icon="share-alt-square"
                />
                <p>
                  <b>Digital communication</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon
                  className="service_icon"
                  icon="fire-extinguisher"
                />
                <p>
                  <b>Crisis management</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon
                  className="service_icon"
                  icon="broadcast-tower"
                />
                <p>
                  <b>Media monitoring & Analysis</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="plug" />
                <p>
                  <b>Community relations</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="cogs" />
                <p>
                  <b>Business-to-business relations</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="smile" />
                <p>
                  <b>Business-to-employee relations</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="puzzle-piece" />
                <p>
                  <b>Business-to-government relations</b>
                </p>
              </div>
              <div className="col-xs-6 col-sm-4 col-md-3 center service_grid">
                <FontAwesomeIcon className="service_icon" icon="file" />
                <p>
                  <b>Case studies</b>
                </p>
              </div>
            </div>
          </Section>
          <br />
          <div className="row">
            <div className="col-xs-12 col-sm-3 col-md-4" />
            <Button
              link="/"
              buttonStyle="dark_btn"
              text="Back home"
              mobileWidth={'6'}
              smallWidth={'3'}
              mediumWidth={'2'}
            />
            <Button
              link="/contact"
              buttonStyle="dark_btn"
              text="Get in touch"
              mobileWidth={'6'}
              smallWidth={'3'}
              mediumWidth={'2'}
            />
          </div>
          <br />
        </div>
      </div>
    )
  }
}

export default ServicesPage



// WEBPACK FOOTER //
// ./src/pages/services.js